import PropTypes from 'prop-types';
import React from 'react';

const Container = ({ children, className, ...rest }) => (
  <div className={`container ${className}`} {...rest}>
    {children}
  </div>
);

Container.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
};

Container.defaultProps = {
  children: [],
  className: '',
};

export default Container;
